import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { FixedWingLineAction } from '../../api/scheduler/models/fixed-wing-line-action';
import {
  FixedWingCrewRemoval,
  FixedWingEligibleCrew,
  FixedWingLine,
  FixedWingSavedLine,
} from '../../features/fixed-wing/models/fixed-wing.models';

export const FixedWingActions = createActionGroup({
  source: 'Fixed Wing',
  events: {
    /** The visible board range; triggers a reload of lines for every date in range. */
    'Set Date Range': props<{ start: string; end: string }>(),

    'Load Lines For Range': emptyProps(),
    'Load Lines For Range Success': props<{ lines: FixedWingLine[] }>(),
    'Load Lines For Range Failure': props<{ error: string }>(),

    /** Eligible crew is loaded on demand for whichever single date the assign form targets. */
    'Load Eligible Crew For Date': props<{ date: string }>(),
    'Load Eligible Crew For Date Success': props<{ date: string; crew: FixedWingEligibleCrew[] }>(),
    'Load Eligible Crew For Date Failure': props<{ error: string }>(),

    /** Saved lines of one date, for Manage Lines. The client merges Line 1–Line 6. */
    'Load Manage Lines': props<{ date: string }>(),
    'Load Manage Lines Success': props<{ date: string; lines: FixedWingSavedLine[] }>(),
    'Load Manage Lines Failure': props<{ error: string }>(),

    /**
     * Saves a line for one date. Custom lines send the next order; an unsaved default
     * sends its own order (and `active` when the first save is an inactivation).
     */
    'Create Line': props<{ date: string; name: string; order: number; active?: boolean }>(),
    'Create Line Success': props<{ line: FixedWingLine }>(),
    'Create Line Failure': props<{ error: string }>(),

    'Update Line': props<{ id: number; date: string; body: { active?: boolean; name?: string } }>(),
    'Update Line Success': props<{ line: FixedWingLine }>(),
    'Update Line Failure': props<{ error: string }>(),

    'Delete Line': props<{ id: number; date: string }>(),
    'Delete Line Success': props<{ id: number; date: string }>(),
    'Delete Line Failure': props<{ error: string }>(),

    /**
     * Saved line: `lineId` only. Unsaved client default: `name` + `order`, never `lineId`.
     */
    'Assign Crew': props<{
      date: string;
      crewIds: number[];
      lineId?: number;
      name?: string;
      order?: number;
    }>(),
    'Assign Crew Success': props<{ line: FixedWingLine; lineCreated: boolean }>(),
    'Assign Crew Failure': props<{ error: string }>(),

    'Move Crew': props<{ sourceLineId: number; crewId: number; targetLineId: number }>(),
    'Move Crew Success': props<{ lines: FixedWingLine[] }>(),
    'Move Crew Failure': props<{ error: string }>(),

    'Remove Crew': props<{ id: number; date: string; crewIds: number[] }>(),
    'Remove Crew Success': props<{ id: number; date: string; removal: FixedWingCrewRemoval }>(),
    'Remove Crew Failure': props<{ error: string }>(),

    'Apply Line Action': props<{ id: number; action: FixedWingLineAction }>(),
    'Apply Line Action Success': props<{ line: FixedWingLine }>(),
    'Apply Line Action Failure': props<{ error: string }>(),

    Refresh: emptyProps(),
  },
});
